import React from 'react'
import PropTypes from 'prop-types'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { omitBy, isNull } from 'lodash'
import constants from '../../constants/constants'

const defaultMeta = {
  title: 'abillion',
  image: {
    url: constants.defaultImage.official,
    type: 'image/jpeg',
    width: '1200',
    height: '630'
  },
  description:
    'Discover & review plant-based dishes and products from anywhere',
  keywords:
    'good eats, vegan, reviews, plant-based, plant based, food, restaurants, dishes, products, sustainable, change'
}

// TODO fix
// eslint-disable-next-line complexity,sonarjs/cognitive-complexity
const Header = ({ meta, canonicalURL, preloadImages }) => {
  // Set a canonical URL on all pages
  const router = useRouter()
  const url = canonicalURL || `${constants.api.root}${router.asPath}`

  const metaWithoutNulls = omitBy(meta, isNull)
  const { title, image, description, keywords, robots } = {
    ...defaultMeta,
    ...metaWithoutNulls
  }
  const imageMeta = image ?? defaultMeta.image

  return (
    <Head>
      <title>{title}</title>
      <meta property="og:title" content={title} />
      <meta property="og:url" content={url} />
      {imageMeta.url && <meta property="og:image" content={imageMeta.url} />}
      {imageMeta.type && (
        <meta property="og:image:type" content={imageMeta.type} />
      )}
      {imageMeta.width && (
        <meta property="og:image:width" content={imageMeta.width} />
      )}
      {imageMeta.height && (
        <meta property="og:image:height" content={imageMeta.height} />
      )}
      <meta name="description" content={description} />
      <meta property="og:description" content={description} />

      <meta name="keywords" content={keywords} />

      {robots && <meta name="robots" content={robots} />}

      <meta name="twitter:title" content={title} />
      {imageMeta.url && (
        <meta name="twitter:image:src" content={imageMeta.url} />
      )}
      <meta name="twitter:description" content={description} />
      <link rel="canonical" href={url} />

      {preloadImages.map((path) => (
        <link key={path} rel="preload" as="image" href={path} />
      ))}
    </Head>
  )
}

Header.propTypes = {
  meta: PropTypes.objectOf(PropTypes.any).isRequired,
  canonicalURL: PropTypes.string,
  isArticle: PropTypes.bool,
  isMap: PropTypes.bool,
  preloadImages: PropTypes.arrayOf(PropTypes.string)
}
Header.defaultProps = {
  canonicalURL: null,
  isArticle: false,
  isMap: false,
  preloadImages: []
}

export default Header
